import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import { type TestIds, getTestProps } from '../../../../utils/testing.ts'
import { useCardContext } from '../../use-card.ts'
import { CardHeadingTag } from '../card-heading/card-heading-tag.tsx'
import { CardHeadingCompactTitle } from './card-heading-compact-title.tsx'

export type CardHeadingCompactProps = PropsWithChildren<
  {
    className?: string
  } & TestIds
>

export const CardHeadingCompactComponent = ({
  children,
  className,
  ...testIds
}: CardHeadingCompactProps) => {
  const { scale } = useCardContext()

  return (
    <div
      className={cn(
        'flex',
        scale === 'sm'
          ? 'flex-col gap-y-0.5 items-start'
          : 'gap-x-2 items-center'
      )}
      {...getTestProps(testIds)}
    >
      {children}
    </div>
  )
}

const CardHeadingCompactNamespace = Object.assign(CardHeadingCompactComponent, {
  Tag: CardHeadingTag,
  Title: CardHeadingCompactTitle,
})

export { CardHeadingCompactNamespace as CardHeadingCompact }
